import { useEffect, useRef } from 'react';

import { useDebounce, useDebouncedCallback } from 'use-debounce';

// most of this helpers was copy from from https://github.com/umijs/hooks/tree/v1.9.0/packages/hooks/src
// the reason why we not install it is coz of devDependencies... we don't need more dependencies we not using

export { useDebounce, useDebouncedCallback };

/**
 * Stores previous value. Useful between component renders to compare next value with previous.
 * @param value any to store
 */
export function usePrevious<T>(value: T): T {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
